<template>
  <div class="">
    <div class="label-standard">State</div>

    <div class="mt-2">
      <select
        :value="value != null ? value : -1"
        :disabled="disabled"
        v-on:change="updateValue({
          objectType: objectType,
          key       : propertyKey, 
          value     : $event.target.value,
          index     : index
        })"
        class="select-standard">
        <option value="-1" disabled="">Select an option...</option>
        <option value="1">ACT</option>
        <option value="2">NSW</option>
        <option value="3">NT</option>
        <option value="4">QLD</option>
        <option value="5">SA</option>
        <option value="6">TAS</option>
        <option value="7">VIC</option>
        <option value="8">WA</option>
        <option value="9">Other</option>
      </select>
    </div>
  </div>
</template>

<script>

  export default {

    props : {

      objectType : {
        type    : String,
        required: false
      },

      value : {
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      disabled : {
        type : Boolean,
        required : false,
        default : false
      }
    },
  }
</script>

<style scoped>

</style>
